module.exports = __webpack_public_path__ + "img/hr-green-croton-04.33e0e92c.png";